import {
  MessageSquare, Type, Languages, Search, FileText, ListChecks, Pencil, HelpCircle,
  Sparkles, RefreshCw, Users,
} from 'lucide-react';

// Everything the home page and the product page both talk about lives here, so
// the two never drift apart and neither owns a second copy of the wording.

export const FEATURES = [
  { icon: MessageSquare, title: 'Caption', desc: 'Loud room, four people talking. Every word gets subtitled.' },
  { icon: Type, title: 'Recall', desc: 'Mid-sentence, you forget the word. It appears on the lens instantly.' },
  { icon: Languages, title: 'Translate', desc: 'The cashier speaks Italian, but you see English automatically.' },
  { icon: Search, title: 'Ask', desc: 'You or someone else asks a question. The answer is there instantly.' },
  { icon: FileText, title: 'Teleprompt', desc: 'Your script scrolls as you speak. You keep eye contact the whole presentation.' },
  { icon: ListChecks, title: 'Recap', desc: 'Forgot something after a conversation? The summary is waiting for you.' },
  { icon: Pencil, title: 'Note', desc: 'Say the idea. It is written down before you forget it.' },
  { icon: HelpCircle, title: 'Question', desc: 'Asked too many things at once? It is all displayed for you to answer.' },
];

export const MARKETPLACE = [
  { icon: Sparkles, title: 'Add abilities', desc: 'Find what fits your day and add it in a tap. It lands on your lens with nothing to set up.' },
  { icon: RefreshCw, title: 'Always growing', desc: 'Updates come over the air, so the pair you buy this year keeps learning new tricks the next.' },
  { icon: Users, title: 'Built by many', desc: 'Anyone can build for the lens, so what KorsaOS can do never stops growing.' },
];

// The two halves of Korsa: what you wear, and what you drive it from.
export const PRODUCT_HALVES = [
  {
    eyebrow: 'Hardware',
    title: 'Glasses',
    points: [
      'Look like ordinary glasses, all day',
      'Live captions, translation, and teleprompter',
      'Prescription lenses available',
    ],
  },
  {
    eyebrow: 'Software',
    title: 'App',
    points: [
      'Review transcripts and summaries',
      'Add abilities from the marketplace',
      'Updates arrive over the air',
    ],
  },
];

// Open roles. The careers page groups them; the home page teases the first few.
export const JOB_CATEGORIES = [
  {
    category: 'Software & AI Engineering',
    jobs: [
      { title: 'Machine Learning Engineer', desc: 'Model development and optimization' },
      { title: 'Data Engineer', desc: 'Data pipeline and processing systems' },
    ],
  },
  {
    category: 'Hardware Engineering',
    jobs: [
      { title: 'Optical Engineer', desc: 'Lens systems and projection technology' },
      { title: 'Electrical Engineer', desc: 'Circuit design and power management' },
      { title: 'Hardware Engineer', desc: 'Embedded systems and hardware validation' },
      { title: 'Audio Engineer', desc: 'Sound processing and optimization' },
      { title: 'Industrial Designer', desc: 'Product design and ergonomics' },
    ],
  },
  {
    category: 'Manufacturing & Operations',
    jobs: [
      { title: 'Manufacturing Engineer', desc: 'Production processes and assembly' },
      { title: 'Supply Chain Specialist', desc: 'Procurement and logistics coordination' },
      { title: 'Operations Coordinator', desc: 'Process optimization and workflow' },
    ],
  },
];

export const ALL_JOBS = JOB_CATEGORIES.flatMap((c) => c.jobs);
